export class PreQuoteAttributes {
    phoneNumber?: string;
    policyNumber?: string;
    groupNumber?: string;
}
